const blockSizes = {
  sm: "28px",
  md: "36px",
  lg: "44px"
};

export { blockSizes };
